import type { useInstitutionalOrderStatus } from './useInstitutionalOrderStatus';
const STATUS_LABELS: Record<string, string> = { ORDER_STATE_NEW: 'New', ORDER_STATE_PARTIALLY_FILLED: 'Partially filled',
  ORDER_STATE_FILLED: 'Filled', ORDER_STATE_CANCELED: 'Canceled', ORDER_STATE_REJECTED: 'Rejected', ORDER_STATE_EXPIRED: 'Expired' };
export function InstitutionalOrderStatus({ status }: { status: ReturnType<typeof useInstitutionalOrderStatus> }) {
  const current = status.current;
  if (!current) return null;
  const evidence = current.data?.evidence;
  const summary = current.busy ? 'Checking order status' : current.failed ? 'Order status unavailable'
    : evidence?.match === 'not_found' ? 'No matching report returned; order status unconfirmed'
    : evidence?.match === 'ambiguous' ? 'Multiple reports returned; order status unconfirmed'
    : evidence?.orders[0]?.state ? (STATUS_LABELS[evidence.orders[0].state] ? `Reported: ${STATUS_LABELS[evidence.orders[0].state]}` : 'Reported status unknown') : 'Reported status unavailable';
  return <div className="border-border/60 border-b px-4 py-2 text-xs" data-testid="institutional-order-status">
    <div className="flex flex-wrap items-center gap-2">
      <span role="status" className="text-muted-foreground">{summary}</span>
      {evidence && <span className="text-muted-foreground">Observed {new Date(evidence.observedAtMs).toLocaleString()}</span>}
      <button type="button" onClick={status.close} className="text-muted-foreground hover:text-foreground underline decoration-dotted">Dismiss order status</button>
    </div>
    <details className="text-muted-foreground mt-1">
      <summary className="cursor-pointer">Order report details</summary>
      <p className="break-all">Order: {current.orderId}.</p>
      <p>This dated report does not update the saved working-order list, assign trader ownership or release reserved funds.</p>
      {evidence?.orders.map((order,index) => <p className="break-all" key={index}>{order.symbol} / {order.state ?? 'Status not supplied'} / {order.side ?? 'Side not supplied'}</p>)}
    </details>
  </div>;
}
